import { disputeViewSchema } from "@redotech/redo-dispute-common/dispute-view-definition";
import {
  disputeReason,
  disputeSortableColumns,
  disputeStatus,
} from "@redotech/redo-dispute-db-schema/dispute-definition";
import { SortDirectionSchema } from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

export const getDisputes = {
  name: "getDisputes" as const,
  input: z.object({
    statuses: z.array(z.enum(disputeStatus)).optional(),
    reasons: z.array(z.enum(disputeReason)).optional(),
    limit: z.number().int().min(1).max(200).optional(),
    offset: z.number().int().min(0).optional(),
    sortBy: z.enum(disputeSortableColumns).optional(),
    sortDirection: SortDirectionSchema.optional(),
  }),
  output: z.object({
    disputes: z.array(disputeViewSchema),
    total: z.number().int(),
  }),
};
